module.exports = __webpack_public_path__ + "img/grid.272baf8c.svg";